/**
 * @generated SignedSource<<bbb59c5c30ca67cb41776028b01d1e91>>
 * @relayHash d3cbb5679b7148d443553094e842e8cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 975565325d728076933658d2fe53e67e0cb762b2b175669521009eca0cb8d845

import type { ConcreteRequest } from 'relay-runtime';
export type SmartButtonRuleOwnerQuery$variables = {
  userId: string;
};
export type SmartButtonRuleOwnerQuery$data = {
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SmartButtonRuleOwnerQuery = {
  response: SmartButtonRuleOwnerQuery$data;
  variables: SmartButtonRuleOwnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "userId"
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SmartButtonRuleOwnerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SmartButtonRuleOwnerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3cbb5679b7148d443553094e842e8cb",
    "id": "975565325d728076933658d2fe53e67e0cb762b2b175669521009eca0cb8d845",
    "metadata": {},
    "name": "SmartButtonRuleOwnerQuery",
    "operationKind": "query",
    "text": "query SmartButtonRuleOwnerQuery($userId:ID!){user:confluence_atlassianUser(id:$userId){id,displayName,photos{value}}}"
  }
};
})();

(node as any).hash = "ada1fd585f01c87fb01f49af6e5a39b5";

export default node;
